import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { withTranslation, useTranslation } from 'react-i18next'
// import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Header from '../../../components/Header/Header';
import AdminRoles from './AdminRoles';
import UsersRoles from './UsersRoles';

import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import AuthorizedMessagePage from "../../../components/AuthorizedMessagePage";
import "./roleManagement.scss"
import { isPermission } from '../../../_helpers/commonAPI';


function TabPanel(props) {
    const { children, value, index, ...other } = props;


    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div p={3}>
                    <Typography>{children}</Typography>
                </div>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));



function RoleManagement() {

    const MyNewClass = useSelector((state) => state.addclasswithstyle.addclasswithstyle);
    const classes = useStyles();
    const { t } = useTranslation();
    const [value, setValue] = React.useState(0);
    const [isPermissionAllow, setIsPermissionAllow] = useState(false);

    const handleChange = async (event, newValue) => {
        setValue(newValue);
    };

    useMemo(async () => {
        const rolePermission = await isPermission("AccessManagement-RolePermissions-view");
        setIsPermissionAllow(rolePermission);
    }, [])


    return (
        <>
            <div className='content-wrapper'>
                <Header title={"Access Management"} />
                <div className={"row ipad_css " + MyNewClass}>
                    <div className='mainScroll'>
                        {isPermissionAllow ?
                            <div className='Shipment_managment'>
                                <div className='col-12'>
                                    <div className="new_tabs mt-3">
                                        <div className={classes.root}>
                                            <AppBar position="static">
                                                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                                    <Tab label={"Role Permissions"} {...a11yProps(0)} style={{ paddingLeft: "8px", paddingRight: "8px" }} />
                                                    <Tab label={"Role Users"} {...a11yProps(1)} style={{ paddingLeft: "8px", paddingRight: "8px" }} />
                                                </Tabs>
                                            </AppBar>

                                            <TabPanel value={value} index={0}>
                                                <AdminRoles />
                                            </TabPanel>
                                            <TabPanel value={value} index={1}>
                                                <UsersRoles />
                                            </TabPanel>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <AuthorizedMessagePage />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default withTranslation()(RoleManagement)
